import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function MobileLocationWarning() {
  return (
    <Box mt={3} textAlign="center">
      <Typography color="error.main" fontWeight={400}>
        Note: This mobile location is shared by multiple items. Moving it will update the base
        location for all of them.
      </Typography>
    </Box>
  );
}
